import type { IApprovable, IApprovableWithValidForApproval } from "entities/types";

function isApprovableWithValidForApproval(item: IApprovable): item is IApprovableWithValidForApproval {
  return item.hasOwnProperty("isValidForApproval");
}

export function isValidForApproval(item: IApprovable) {
  if (isApprovableWithValidForApproval(item)) {
    return item.isValidForApproval;
  }

  return true;
}
